import PropTypes from 'prop-types'
import React from 'react'

import PlayerContext from './PlayerContext'

export default function PlayerProvider(props) {
  const { children, player } = props

  return (
    <PlayerContext.Provider value={player}>{children}</PlayerContext.Provider>
  )
}

PlayerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  player: PropTypes.shape({}).isRequired,
}
